type TPublicLayoutProps = {
  children?: any
}
const PublicLayout = ({ children }: TPublicLayoutProps) => {
  return children
}
export default PublicLayout
